/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Order class.
 */
export enum OrderClass {
    MARKET = 'market',
    LIMIT = 'limit',
    LIQUIDITY = 'liquidity',
}
